{
  "colorInputLabel": "{label}、{channelLabel}",
  "colorNameAndValue": "{name}：{value}",
  "colorPicker": "拾色器",
  "twoDimensionalSlider": "2D 滑块",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
